<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="cs-homework-title">我的文件</span>
      </el-col>
    </el-row>
    <el-row>
      <pagination
        v-loading="loading"
        :data="listData"
        :option="paginationOption"
        @delete="onDelete"
      ></pagination>
    </el-row>
    <el-row class="cs-studentHomeworkFileList-bottom">
      <div  v-if="!data.isEnd && !data.isCompleted">
        <el-button type="primary" size="small" :disabled="uploadDisabled" @click="onUploadClick">
          <i class="el-icon-upload"></i>上传文件
        </el-button>
         <span class="cs-color-frenchgrey">上传文件大小不超过35M</span>
      </div>
      <span v-if="data.isEnd">已超过截止时间，无法上传文件</span>
      <span v-if="data.isCompleted">已完成，无法上传文件</span>
    </el-row>
    <el-dialog
        center
        title="上传作业文件"
        :show-close="true"
        :close-on-click-modal="false"
        width="700px"
        :visible.sync="homeworkFileUploaderVisible"
        top="8vh"
      >
        <blobUploader
          @closeEditor="onCloseFileUploader"
          @blobUploadError="onFileUploadError"
          @blobUploaded="onFileUploaded"
          :isAutoSave="true"
          :type="8"
          :accepts="'.png,.jpg,.jpeg,.txt,.pdf,.doc,.docx,.xls,.xlsx,.csv,.html,.css,.js,.zip,.py,.c,.cc,.cpp,.rmd,.rkt,.zip,.rar'"
          :maxNameLength="32"
          :isVisible="homeworkFileUploaderVisible"
          :isCDN=true
        ></blobUploader>
      </el-dialog>
  </div>
</template>

<style lang="scss">
.cs-studentHomeworkFileList-bottom{
  margin-top: 20px;

  .el-button{
    margin-right: 5px;
    i{
      margin-right: 3px;
      font-size: 12px;
    }
  }
}
</style>

<script>
import {
  getStudentHomeworkFileList,
  deleteStudentHomeworkFile,
  saveStudentHomeworkFile
} from "../../service/homework.service";
import pagination from "../common/pagination";
import blobUploader from "../fileHandler/blobUploader";
import { formatDate } from "../../config/mUtils";
import global_ from "@/core/global";

export default {
  props: {
    data:{
      studentHomeworkId: Number,
      isEnd: Boolean,
      isCompleted: Boolean
    }

  },
  data() {
    return {
      loading: false,
      listData: {},
      paginationOption: {},
      uploadDisabled: false,
      homeworkFileUploaderVisible: false
    };
  },
  components: {
    pagination,
    blobUploader
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      editButtonText: "查看",
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      editColumnTite: "详情查看",
      showAcitveColor: true,
      hideDisableRow: true,
      hasDeleteButton: true,
      fnRowDeleteVisible: this.onRowDeleteVisible
    };
    this.init();
  },
  methods: {
    init(){
      this.getListData();
    },
    onRowDeleteVisible(index, row) {

        if (this.data.isEnd || this.data.isCompleted){
          return false;
        }
        return true;
    },
    onCloseFileUploader() {
      this.closeFileUploader();
    },
    onFileUploadError() {},
     closeFileUploader() {
      this.homeworkFileUploaderVisible = false;
    },
    onFileUploaded(data) {
      if (!!data) {
        this.closeFileUploader();
        let fileId = data.FileId;
        saveStudentHomeworkFile(this.data.studentHomeworkId, fileId).then(result =>{
          if (!!result && result.success){
            this.getListData();
            this.$emit("fileChange");
          }else{
            if (!!result.message){
              this.$message.error(result.message);
            }
          }
        });

      } else {
        this.closeFileUploader();
      }
    },
    onUploadClick() {
      this.homeworkFileUploaderVisible = true;
    },
    getListData() {
      if (!this.data || !this.data.studentHomeworkId){
        return;
      }
      this.loading = true;
      getStudentHomeworkFileList(this.data.studentHomeworkId)
        .then(result => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onDelete(index, row) {
      let id = row.Id;
      if (!id) {
        return;
      }
      let fileName = row.FileName;
      this.$confirm("您确定要删除文件" + fileName + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteStudentHomeworkFile(id).then(result => {
            if (!!result && result.success) {
              this.$message.success("删除成功");
              this.listData.Results.splice(index, 1);
              this.$emit("fileChange");
            }
          });
        })
        .catch(() => {});
    }
  },
  watch:{
    data: function(){
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/studentHomeworkFileList.vue